module.exports = __webpack_public_path__ + "img/new-book-bg.77e095b2.png";